import { render, staticRenderFns } from "./page_header_mobile.vue?vue&type=template&id=02db4979&scoped=true"
import script from "./page_header_mobile.vue?vue&type=script&lang=js"
export * from "./page_header_mobile.vue?vue&type=script&lang=js"
import style0 from "./page_header_mobile.vue?vue&type=style&index=0&id=02db4979&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02db4979",
  null
  
)

export default component.exports